import { useScrollOffset } from '@graphcommerce/framer-next-pages'
import { LayoutProvider } from '@graphcommerce/next-ui/Layout/components/LayoutProvider'
import { useTransform, useScroll } from 'framer-motion'
import { useContext } from 'react'
import { useMergeCustomerCart } from '../../hooks/Cart/useMergeCustomerCart'
import { globalContext } from '../NextUi/globalContext'
import { useCustomerValidateToken } from '../../hooks/Customer/useCustomerValidateToken'

export type LayoutDefaultProps = {
  header: React.ReactNode
  footer: React.ReactNode
  children?: React.ReactNode
  mainClassName?: string
}

export function LayoutDefault(props: LayoutDefaultProps) {
  const { footer, header, children, mainClassName } = props
  const { blurBackground } = useContext(globalContext)
  const scrollWithOffset = useTransform(
    [useScroll().scrollY, useScrollOffset()],
    ([y, offset]: number[]) => y + offset,
  )

  useMergeCustomerCart()

  useCustomerValidateToken()

  return (
    <LayoutProvider scroll={scrollWithOffset}>
      <div className='flex min-h-[100vh] flex-col justify-between'>
        {header}
        <main className={`${mainClassName} bg-white ${blurBackground ? 'blur-sm' : 'blur-none'}`}>
          {children}
        </main>
        {footer}
      </div>
    </LayoutProvider>
  )
}
